import {Dispatch, FC, useRef} from 'react';
import {FormGroup} from '@mui/material';
import {Form, Formik} from 'formik';
import classNames from 'classnames';
import {keyCodes} from '../../../constants/constants';
import {CellItemProps} from '../../../constants/types';
import useOnOutsideClick from '../../../hooks/useOnOutsideClick';
import TextField from '../formik/fields/TextField';

type EditModeProps = {
  cellItem: CellItemProps,
  setIsUpdating: Dispatch<boolean>,
  isEditMode: boolean,
  isTimeInput?: boolean,
  setEditMode: Dispatch<boolean>,
  validationSchema: any,
  initialTouched?: {[field: string]: boolean}
}

const EditMode: FC<EditModeProps> = ({
  cellItem,
  setIsUpdating,
  isEditMode,
  setEditMode,
  validationSchema,
  initialTouched,
  isTimeInput
}) => {
  const ref = useRef<HTMLInputElement>(null);
  const {rowId, cellData, editHandler} = cellItem;

  const initialValues = {...cellData};
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnBlur={false}
      onSubmit={() => {}}
      initialTouched={initialTouched}
    >
      {({errors, values, dirty}) => {
        const submit = async () => {
          const hasErrors =
            Object.keys(cellData).some((key) => errors[key]);

          if (hasErrors) {
            setEditMode(false);
          } else if (!dirty) {
            setEditMode(false);
          } else if (dirty) {
            setEditMode(false);
            if (editHandler) {
              setIsUpdating(true);
              await editHandler(rowId, values);
              setIsUpdating(false);
            }
          }
        };

        useOnOutsideClick(
            isEditMode,
            ref,
            submit,
            [JSON.stringify(values), JSON.stringify(errors)]
        );

        const handleKeyPress = async (event) => {
          const {keyCode} = event;

          if (keyCode === keyCodes.ESCAPE) {
            setEditMode(false);
          }

          if (keyCode === keyCodes.ENTER) {
            await submit();
          }
        };

        return <Form>
          <div ref={ref} className="form-group">
            {Object.keys(cellData).map((key, index) => (
              <div className={classNames('editable__cell', {'time': isTimeInput})} key={`editable_cell_${rowId}_${index}_${key}`}>
                <div className="field-wrapper">
                  <FormGroup>
                    <TextField
                      size="small"
                      id={key}
                      name={key}
                      onKeyDown={async (event) => {
                        await handleKeyPress(event);
                      }}
                    />
                  </FormGroup>
                </div>
              </div>
            ))}
          </div>
        </Form>;
      }}
    </Formik>);
};

export default EditMode;
